import styled from 'styled-components';

export const PaymentSelectionContainer = styled.div`
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr;
    width: 100%;
    margin-top: 30px;

    input[type='radio'] {
        margin: 20px 20px 20px 0;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/FunnelPaymentSelectionStepStyle.js